import React, { useState } from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';
// import Status from '../status';
import style from './style.module.scss';
import { ReactComponent as Check } from 'assets/images/fabricQualities/Check.svg';

const RadioFieldInput = ({
  name,
  label,
  isRequired = false,
  options,
  isMultipleAllowed = false,
  onSelect,
  isDisabled = false,
  boxClasses = '',
}) => {
  return (
    <Field name={name}>
      {({ field, meta: { error, touched }, form: { setFieldValue, values } }) => {
        const handleClick = (option) => {
          if (isDisabled) return;

          if (isMultipleAllowed) {
            const current = values[name] || [];
            const exists = current.includes(option.id);
            const updated = exists
              ? current.filter((id) => id !== option.id)
              : [...current, option.id];
            setFieldValue(name, updated);
            onSelect?.(updated);
          } else {
            setFieldValue(name, option.id);
            onSelect?.(option.id);
          }
        };

        return (
          <div className={style['input-wrapper']}>
            {label && (
              <p className={style.label}>
                <span>{label}</span>
                {/* {isRequired && (
                  <Status
                    isFilled={
                      isMultipleAllowed ? (field.value?.length > 0) : Boolean(field.value)
                    }
                  />
                )} */}
              </p>
            )}

            <div className={`flex ${boxClasses}`}>
              {options.map((option) => {
                const isSelected = isMultipleAllowed
                  ? field.value?.includes(option.id)
                  : field.value === option.id;

                return (
                  <div
                    key={option.id}
                    className={style[isSelected ? 'btnClick' : 'btn']}
                    style={{
                      color: isDisabled ? '#5a5a5a' : '#0167e2',
                      cursor: isDisabled ? 'not-allowed' : 'pointer',
                      opacity: isDisabled ? 0.6 : 1,
                    }}
                    onClick={() => handleClick(option)}>
                    <div className={style['box']}>
                      {isSelected && <Check />}
                      <span style={{ color: isSelected ? '#0167e2' : '#5a5a5a' }}>
                        {option.name}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>

            {touched && error && <p className={style.error}>{error}</p>}
          </div>
        );
      }}
    </Field>
  );
};

RadioFieldInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.any.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  isMultipleAllowed: PropTypes.bool,
  onSelect: PropTypes.func,
  isDisabled: PropTypes.bool,
  boxClasses: PropTypes.string,
};

export default RadioFieldInput;
